export enum AgreementActionType {
  EXPIRY = 'EXPIRY',
  CHANGE = 'CHANGE',
  BACKDATE = 'BACKDATE',
  RENEW = 'RENEW',
  EXTEND = 'EXTEND',
  REMOVE = 'REMOVE',
  VALIDATE = 'VALIDATE',
  CREATE = 'CREATE',
}
